<template>
    <v-dialog v-model="dialogVisible" max-width="450" persistent>
        <v-card elevation="0">
            <v-card-title>
                <span style="font-weight: 700; font-size: 1rem">Change your password</span>
                <v-spacer />
                <v-icon @click="dialogVisible = false" small>mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-5">
                <v-text-field label="New password" filled dense append-icon="mdi-eye" v-model="password"
                    @keyup.enter="changePasswordFn" @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'text' : 'password'" />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn outlined class="text-none" @click.stop="changePasswordFn">Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ChangePasswordDialog',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        password: null,
        showPassword: false,
    }),
    computed: {
        ...mapGetters({ get_user: 'auth/get_user' }),
        dialogVisible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        async changePasswordFn() {
            if (this.password == null) {
                this.$toast.error('Please put something first');
                return;
            }
            this.$toast.info('please wait...');
            try {
                await this.$axios.patch(`/api/users/password/${this.get_user.id}`, { password: this.password });
                this.$toast.success('changing password successful!');
                this.password = null;
                this.showPassword = false;
                this.dialogVisible = false;
            } catch (error) {
                console.error('error on updating password - component level', error);
                this.$toast.error('Failed to change password');
            }
        },
    },
};
</script>
